module.exports = __webpack_public_path__ + "media/images/icons/sports-slider-arrow-right-1e8e836fb72bd1b3294e33a1b0aaf877.svg";